import { render, staticRenderFns } from "./VectorDetailsInfo.vue?vue&type=template&id=654784a7&scoped=true&"
import script from "./VectorDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./VectorDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./VectorDetailsInfo.vue?vue&type=style&index=0&id=654784a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654784a7",
  null
  
)

export default component.exports